import {Component, OnInit, ViewChild} from '@angular/core';
import {NgbCarousel, NgbSlideEvent, NgbSlideEventSource} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
// import {CookieService} from 'ngx-cookie-service';
// // Import the functions you need from the SDKs you need
// import {initializeApp} from 'firebase/app';
// import {getAnalytics} from 'firebase/analytics';
// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries
//
// // Your web app's Firebase configuration
// // For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//     apiKey: 'AIzaSyA2Yvg3MWO_PbNwTvwDfJZ9SdT8EqJALs0',
//     authDomain: 'his-90746.firebaseapp.com',
//     projectId: 'his-90746',
//     storageBucket: 'his-90746.appspot.com',
//     messagingSenderId: '517604437042',
//     appId: '1:517604437042:web:308500daa31a397c28e02b',
//     measurementId: 'G-PVX61P38PB'
// };


@Component({
    selector: 'app-landing',
    templateUrl: './landing.component.html',
    styleUrls: ['./landing.component.scss'],
})

export class LandingComponent implements OnInit {
    @ViewChild('carousel', {static: true}) carousel: NgbCarousel;

    paused = false;
    unpauseOnArrow = false;
    pauseOnIndicator = false;
    pauseOnHover = true;
    pauseOnFocus = true;

    outService = [
        {
            name: 'img1',
            img: 'assets/img/Our Services/img1.png'
        },
        {
            name: 'img2',
            img: 'assets/img/Our Services/img2.png'
        },
        {
            name: 'img3',
            img: 'assets/img/Our Services/img3.png'
        },
        {
            name: 'img4',
            img: 'assets/img/Our Services/img4.png'
        },
        {
            name: 'img5',
            img: 'assets/img/Our Services/img5.png'
        },
        {
            name: 'img6',
            img: 'assets/img/Our Services/img6.png'
        },
        {
            name: 'img7',
            img: 'assets/img/Our Services/img7.png'
        },
        {
            name: 'img8',
            img: 'assets/img/Our Services/img8.png'
        },
        {
            name: 'img9',
            img: 'assets/img/Our Services/img9.png'
        },
        {
            name: 'img10',
            img: 'assets/img/Our Services/img10.png'
        },
        {
            name: 'img11',
            img: 'assets/img/Our Services/img11.png'
        },
    ]

    constructor(
        private router: Router
    ) {
    }

    ngOnInit() {
    }

    togglePaused() {
        if (this.paused) {
            this.carousel.cycle();
        } else {
            this.carousel.pause();
        }
        this.paused = !this.paused;
    }

    onSlide(slideEvent: NgbSlideEvent) {
        if (this.unpauseOnArrow && slideEvent.paused &&
            (slideEvent.source === NgbSlideEventSource.ARROW_LEFT || slideEvent.source === NgbSlideEventSource.ARROW_RIGHT)) {
            this.togglePaused();
        }
        if (this.pauseOnIndicator && !slideEvent.paused && slideEvent.source === NgbSlideEventSource.INDICATOR) {
            this.togglePaused();
        }
    }

    markerClicked(location) {
        let url = null;
        if (location === 'hq') {
            url = 'https://www.google.co.th/maps/place/Fintechinno+Co.,Ltd./@13.7267144,100.5124247,17z/data=!3m1!4b1!4m5!3m4!1s0x30e298c6e9fcb843:0xa55819ad22ef51d4!8m2!3d13.7267144!4d100.5146134';
        } else if (location === 'work') {
            url = 'https://www.google.co.th/maps/place/Digital+Working+Space/@13.8466629,100.6199291,19.08z/data=!4m5!3m4!1s0x0:0x17016722bd1f82ce!8m2!3d13.8469012!4d100.6204071';
        }
        window.open(url, '_blank');
    }

    gotoUrl(web) {
        const url = 'http://www.' + web + '.com';
        window.open(url, '_blank');
    }

    openPolicy() {
    }

}
